import { render } from "./1_Load.vue?vue&type=template&id=6a7bf5df"
import script from "./1_Load.vue?vue&type=script&lang=ts"
export * from "./1_Load.vue?vue&type=script&lang=ts"
script.render = render

export default script